module.exports = __webpack_public_path__ + "static/media/andhra_pradesh.d296a81c.png";